import React from "react";
import TextField from "@mui/material/TextField";
import PropTypes from "prop-types";

// Notes deserve real space: the old hardcoded slice(0, 160) silently
// swallowed everything past ~1.5 sentences with no counter or warning
// (Matthew, 2026-07-20: "at least a couple solid paragraphs"). The
// backing columns (DocumentShare.notes / DocumentReviewHistory
// .comment_text) are unbounded TextFields, so the cap is purely a UI
// choice. A counter appears once the user is within 80% of the limit.
const DEFAULT_MAX_LENGTH = 1000;

const MultilineTextField = ({ value, onChange, placeholder, maxLength = DEFAULT_MAX_LENGTH }) => {
  const showCounter = (value?.length || 0) >= maxLength * 0.8;
  return (
    <TextField
      fullWidth
      multiline
      minRows={4}
      maxRows={10}
      placeholder={placeholder}
      size="small"
      value={value}
      onChange={(e) => onChange(e.target.value.slice(0, maxLength))}
      helperText={showCounter ? `${value.length}/${maxLength}` : undefined}
      sx={{
        fontSize: "13px",
        "& .MuiInputBase-input::placeholder": {
          fontFamily: "Manrope",
          color: "#5A6C87",
          fontSize: "13px",
          fontWeight: "500",
          opacity: "1",
          lineHeight: "20px",
        },
        "& .MuiOutlinedInput-root": {
          borderRadius: "6px",
          padding: "6px 10px",
          fontSize: "13px",
          "& fieldset": {
            borderColor: "#DDE2E9",
          },
          "&:hover fieldset": {
            borderColor: "#0C53BB",
          },
          "&.Mui-focused fieldset": {
            border: "1px solid",
            borderColor: "#0C53BB",
            boxShadow: "0px 0px 0px 2px rgba(12, 83, 187, 0.2)",
          },
        },
      }}
    />
  );
};

MultilineTextField.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  maxLength: PropTypes.number,
};

export default MultilineTextField;
